export default {
    it: {
        "title": "Allegato facoltativo",
        "drop-message": "Trascina i file qui o <span class='filepond--label-action'>Carica file</span>",
        "file-formats": "Tipi di file consentiti: jpg, png, gif, pdf.",
        "max-dim": "La dimensione massima consentita per allegato è di: 1MB.",
        "max-file-number": "Numero massimo di allegati: 5.",
        "upload": "Carica file"


    },
    en: {
        "title": "Application submitted",
        "drop-message": "Drop files here or <span class='filepond--label-action'>Browse</span>",
        "file-formats": "Allowed file types: jpg, png, gif, pdf, p7e e p7m.",
        "max-dim": "The maximum allowed size per attachment is: 1MB.",
        "max-file-number": "Maximum number of attachments: 5.",
        "upload": "Upload file"
    }
}